import script from "./SfxImageGallerySmall.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxImageGallerySmall.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QImg,QIcon});qInstall(script, 'directives', {TouchHold});
